// Time on duty, worked out on the page. Check-in / check-out are stored as
// "HH:MM" India time for the day (see TimeLogs.checkIn), and `hours` is only
// written at check-out — so "how long have I been in" is computed here.

/** Minutes since midnight, India time. */
export function istMinutesNow(now = new Date()): number {
  const [h, m] = now.toLocaleTimeString('en-GB', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false }).split(':').map(Number);
  return (h % 24) * 60 + m;
}

function toMinutes(hhmm?: string | null): number | null {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(hhmm || ''));
  return m ? (Number(m[1]) % 24) * 60 + Number(m[2]) : null;
}

/** Minutes worked today: check-in → check-out, or → now while still in. */
export function minutesOnDuty(checkIn?: string | null, checkOut?: string | null, now = new Date()): number {
  const start = toMinutes(checkIn);
  if (start === null) return 0;
  const end = toMinutes(checkOut) ?? istMinutesNow(now);
  return Math.max(0, end - start);
}

export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h ? `${h}h ${m}m` : `${m}m`;
}

/** "09:42" → "9:42 am" for display. */
export function formatClock(hhmm?: string | null): string {
  const t = toMinutes(hhmm);
  if (t === null) return '—';
  const h = Math.floor(t / 60);
  const m = String(t % 60).padStart(2, '0');
  return `${h % 12 || 12}:${m} ${h < 12 ? 'am' : 'pm'}`;
}
